const navData =[
    {
        id : 1,
        link:'/',
        name:'Home',
    },
    {
        id : 2,
        link:'/about',
        name:'About',
    },
    {
        id : 3,
        link:'/projects',
        name:'Projects',
    },
    {
        id : 4,
        link:'/contact',
        name:'Contact',
    },
]

export default navData;